import { Dimensions, Platform, StatusBar, StyleSheet } from 'react-native'

import { DS } from '../../design-system'
import { moderateScale } from '../../styles/sizes'
import { color } from '../../theme'
import { fontFamily } from '../../theme/fontFamily'

const window = Dimensions.get('window')
const IMAGE_HEIGHT = window.height / 3

export const startStyles = StyleSheet.create({
  container: {
    flex: 1
  },
  questionOptions: { gap: 8 },
  startContainer: {
    flex: 1,
    backgroundColor: '#7B043D',
    paddingTop: Platform.OS === 'android' ? StatusBar.currentHeight : 0
  },
  startBackground: { flex: 1, backgroundColor: DS.palette['Brand/Maroon'], paddingBottom: 20 },
  image: {
    flex: 1,
    resizeMode: 'cover',
    justifyContent: 'center'
  },
  text: {
    color: 'white',
    fontSize: 42,
    fontWeight: 'bold',
    textAlign: 'center',
    backgroundColor: '#000000a0'
  },
  keyboardContainerStyle: {
    flex: 1,
    justifyContent: 'center',
    width: '100%',
    alignItems: 'center'
  },
  errorMessage: {
    textAlign: 'center',
    color: 'red',
    fontSize: 13,
    fontFamily: fontFamily.sfProTextRegular
  },
  NameInput: {
    width: '80%',
    height: 52,
    textAlign: 'center',
    backgroundColor: '#fff',
    borderRadius: 6,
    borderWidth: 1,
    borderColor: '#E4E4E4',
    color: '#353535'
  },
  joinText: {
    textAlign: 'center',
    fontWeight: '800',
    fontSize: 20,
    fontFamily: fontFamily.sfProDisplayHeavy
  },
  logo: {
    height: IMAGE_HEIGHT,
    resizeMode: 'contain',
    marginBottom: 20,
    padding: 10,
    marginTop: 20
  },
  logoContainer: {
    flex: 0.8,
    justifyContent: 'center',
    paddingTop: 10
  },
  inputContainer: {
    flex: 1.2,
    justifyContent: 'center',
    width: '100%',
    alignItems: 'center'
  },
  backText: {
    color: '#49CDF2',
    fontWeight: '900',
    textTransform: 'uppercase',
    fontFamily: fontFamily.sfProDisplayHeavy
  },
  enterCodeMessage: {
    fontSize: moderateScale(22),
    color: '#49CDF2',
    fontWeight: '900',
    textAlign: 'center',
    paddingHorizontal: 35,
    fontFamily: fontFamily.sfProDisplayHeavy
  },
  backButton: {
    alignSelf: 'flex-start',
    marginLeft: 27,
    marginTop: 4,
    color: '#49CDF2'
  },
  question: {
    fontWeight: '400',
    fontFamily: fontFamily.FeatureDeckRegular,
    color: '#121212',
    fontSize: 28,
    lineHeight: 34
  },
  title: {
    marginTop: 32,
    fontWeight: 'bold',
    fontFamily: fontFamily.GTAmericaStandardMedium,
    color: '#121212',
    fontSize: 16
  },
  nameLength: {
    marginTop: 32,
    fontWeight: 'bold',
    fontFamily: fontFamily.GTAmericaStandardRegular,
    color: '#68706D',
    fontSize: 14
  },
  nameContainer: {
    gap: 8
  },
  inputField: {
    height: 50,
    padding: 15,
    borderRadius: 4,
    fontSize: 16,
    paddingStart: 10,
    borderWidth: 1,
    fontFamily: fontFamily.GTAmericaStandardRegular
  },
  buttonStyle: {
    height: moderateScale(48),
    width: '100%',
    backgroundColor: '#121212',
    borderRadius: 48,
    position: 'absolute',
    bottom: 25,
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row'
  },
  buttonView: {
    paddingHorizontal: 40,
    alignSelf: 'center',
    padding: 2
  },
  buttonText: {
    color: '#FFFFFF',
    fontWeight: '500',
    fontSize: 16,
    fontFamily: fontFamily.GTAmericaStandardMedium
  },
  nameCotainer: {
    flex: 1,
    backgroundColor: '#F6F2E9'
  },
  firstSlide: {
    paddingHorizontal: 24,
    paddingTop: 24
  },
  questionsAndFooter: { gap: 24 },
  slide: {
    flex: 1,
    paddingHorizontal: 24,
    paddingTop: 24,
    gap: 32
  },
  header: {
    width: '100%',
    height: Platform.OS === 'ios' ? 55 : 45,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center'
  },
  headerTitle: {
    fontSize: 16,
    fontWeight: '500',
    color: '#121212',
    fontFamily: fontFamily.GTAmericaStandardMedium
  },
  optionView: {
    paddingHorizontal: 16,
    paddingVertical: 12,
    flexDirection: 'row',
    gap: 8,
    borderRadius: 5,
    width: '100%',
    borderWidth: 1,
    alignItems: 'center'
  },
  optionText: {
    flexShrink: 1,
    flexWrap: 'wrap'
  },
  buttonFrame: { paddingHorizontal: 24, paddingVertical: 16 },
  loadingStyle: {
    width: 20,
    height: 20,
    right: 0,
    position: 'absolute',
    top: 3
  },
  multipleSelect: {
    marginTop: 6,
    marginBottom: 10,
    color: '#121212',
    fontWeight: '400',
    fontSize: 18,
    fontFamily: fontFamily.GTAmericaStandardRegular
  },
  radioIcon: { height: 16, width: 16, resizeMode: 'contain', marginHorizontal: 16 },
  playingImage: {
    height: '100%',
    width: '100%',
    position: 'absolute'
  },
  middleView: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    gap: 16
  },
  centerText: {
    textAlign: 'center'
  },
  eventContainer: {
    flex: 1,
    backgroundColor: '#F6F2E9',
    paddingHorizontal: 24,
    justifyContent: 'space-between'
  },
  eventQuestionText: {
    fontFamily: fontFamily.FeatureDeckRegular,
    textAlign: 'center',
    fontSize: 28,
    color: '#121212'
  },
  button2: {
    backgroundColor: color.backgroundColor,
    marginVertical: 15,
    borderWidth: 1,
    borderColor: color.border
  }
})
